import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import HttpApi from "i18next-http-backend";
import { I18nProvider } from "@refinedev/core";

// Initialize i18next instance
i18n
  .use(HttpApi) // Loads translations from the /public folder
  .use(initReactI18next) // Passes i18n down to react-i18next
  .init({
    supportedLngs: ["en", "vi"],
    fallbackLng: "en",
    lng: localStorage.getItem("i18nextLng") || "en", // Set initial language
    backend: {
      loadPath: "/locales/{{lng}}/translation.json",
    },
    // Allows for nested keys like "buttons.save"
    keySeparator: ".",
    interpolation: {
      escapeValue: false, // React already safes from xss
    },
    debug: import.meta.env.DEV, // Enable debug in development
  });

// Create a Refine i18nProvider
export const i18nProvider: I18nProvider = {
  translate: (key: string, options?: object) => i18n.t(key, options as any) as string,
  changeLocale: (lang: string) => i18n.changeLanguage(lang),
  getLocale: () => i18n.language,
};

export default i18n;
